import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingSevenSlice = createSlice({
  name: 'customCounsellingSeven',
  initialState: {
    allDataSeven: null,
  },
  reducers: {
    setAllDataSeven: (state, action) => {
      state.allDataSeven = action.payload;
    },
  },
});

export const { setAllDataSeven } = customCounsellingSevenSlice.actions;
export default customCounsellingSevenSlice.reducer;
